"use strict";

var claimProject = {
  _token: $.jStorage.get("localToken"),
  _open_id: "",
  _userInformation: null,
  init: function init() {
    this._open_id = UTL.getUrlParam("id");
    UTL.getuserInformationData(claimProject._token, function (data) {
      claimProject._userInformation = data.user_information;
      claimProject.render();
      claimProject.handleEvent.init();
    })
  },
  render: function render() {
    showLoadingGif();
    claimProject.editView();
    claimProject.getProjectDetail(claimProject._open_id, claimProject.indexView);
  },
  getProjectDetail: function getProjectDetail(datas, cb) {
    var that = this;
    $.ajax({
      url: v1url + 'project-claim/claim-project-introduction',
      type: "GET",
      data: {
        open_id: datas
      },
      headers: {
        token: claimProject._token
      },
      success: function success(data) {
        if (data.code === -1) {
          reLoginOnUc();
          return;
        } else if (data.code === 1000) {
          cb && cb(data.data);
        } else {
          showWarning(data.message);
        }
        closeLoadingGif();
      }
    });
  },
  submitClaim: function submitClaim(datas, cb) {
    var that = this;
    showLoadingGif();
    $.ajax({
      url: v1url + 'project-claim/add',
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(datas),
      headers: {
        token: claimProject._token
      },
      success: function success(data) {
        if (data.code === -1) {
          reLoginOnUc();
          return;
        } else if (data.code === 1000) {
          cb && cb(data);
        } else {
          showWarning(data.message);
        }
        closeLoadingGif();
      }
    });
  },
  indexView: function indexView(data) {
    var projectData = data;
    var _html = "";
    _html += "\n        <div class=\"head-left\">\u60A8\u6B63\u5728\u7533\u8BF7\u8BA4\u9886\u7684\u9879\u76EE\uFF1A</div>\n                <div class=\"head-center\">\n                    <img class=\"logo\" src=" + (projectData.logo ? projectData.logo : "") + " alt=\"\">\n                    <div class=\"project-introduce\">\n                        <div class=\"business-name\">" + (projectData.name ? projectData.name : "未填写") + "</div>\n                        <div class=\"industry\">" + (projectData.industry ? projectData.industry : "未填写") + "</div>\n                        <div class=\"introduce\">" + (projectData.introduce ? projectData.introduce : "未填写") + "</div>\n                    </div>\n                </div>\n                <div class=\"head-right\"><a href='projectdetail/" + claimProject._open_id + "' target='_blank'><span class=\"project-detail\">\u67E5\u770B\u9879\u76EE\u8BE6\u60C5</span></a></div>\n        ";
    $(".box .index-box .index-claim .claim-head").html(_html);
  },
  editView: function editView() {
    var certData = {
      tempCertState: claimProject._userInformation.is_cert,
      tempPhone: claimProject._userInformation.phone ? claimProject._userInformation.phone : '',
      cert_name: claimProject._userInformation.name ? claimProject._userInformation.name : '',
      cert_email: claimProject._userInformation.email ? claimProject._userInformation.email : ''
    };
    // console.log(certData)
    var _html = "";

    if (certData.tempCertState == 1) {
      _html += `
      <div class="form-subtitle">创业者与FA身份可以认领成功，请在认领之前，前往个人中心选择您的身份，提高认领成功效率。</div>
      <div class="input-item clearfix"> <label for="">微信：</label> <input type="text" name="wechat" placeholder="请输入认领人的常用微信">
      </div>
      <div class="input-item clearfix">
          <label for="">担任职务：</label> <input type="text" name="job" placeholder="请输入担任职务">
      </div>
      <div class="input-item clearfix "> <label for="">工作名片：</label>
          <div class="img-box">
              <div class="sub-img" id="replace_logo_father"> 本地上传 <input type="file" accept="image/*" name="" id="replace_logo">
              </div>
          </div>
          <div class="title-box">
              <div class="replace-img" id="replace_logo_father" style="display:none"> 更换名片 <input type="file" accept="image/*"
                      name="" id="replace_logo">
              </div>
              <p class="title">请上传清晰可见、容易识别的照片，支持JPG，JPEG，PNG格式</p>
          </div>
      </div>
      <div class="userInformation-box">
          <div class="cert_subtitle cert_subtitle_investor"><span class="icon"></span>您已认证为投资人，以下信息不可修改
          </div>
          <div class="input-item clearfix"> <label class="label-disabled" for="">手机号码：</label>
              <input class="input-disabled" name="phone" type="text" disabled value=${certData.tempPhone} placeholder="联系人的电话">
          </div>
      </div>
      <div class="input-item clearfix"> <label class="label-disabled" for="">真实姓名：</label>
          <input class="input-disabled" type="text" disabled name="real_name" value=${certData.cert_name} placeholder="请输入认领人的真实姓名">
      </div>
      <div class="input-item clearfix"> <label class="label-disabled" for="">邮箱：</label> <input class="input-disabled" type="text"
              disabled name="email" value=${certData.cert_email} placeholder="建议使用包含公司域名后缀的邮箱">
      </div>
      <div class="submit-btn"> <span id="claimProject" class="btn-right" data-key="claimProject">提交认领认证</span>
      </div>
      `
      $(".index-claim .edit").html(_html);
    } else {
      _html += `
      <div class="form-subtitle">若您是创业者或者FA身份，在认领项目之前，请前往个人中心选择您的身份</div>
      <div class="input-item clearfix"> <label for="">微信：</label> <input type="text" name="wechat" placeholder="请输入认领人的常用微信">
      </div>
      <div class="input-item clearfix">
          <label for="">担任职务：</label>
          <input type="text" name="job" placeholder="请输入担任职务">
      </div>
      <div class="input-item clearfix ">
          <label for="">工作名片：</label>
          <div class="img-box">
              <div class="sub-img" id="replace_logo_father">
                  本地上传 <input type="file" accept="image/*" name="" id="replace_logo"> </div>
          </div>
          <div class="title-box">
              <div class="replace-img" id="replace_logo_father" style="display:none">
                  更换名片 <input type="file" accept="image/*" name="" id="replace_logo"> </div>
              <p class="title">请上传清晰可见、容易识别的照片，支持JPG，JPEG，PNG格式</p>
          </div>
      </div>
      <div class="userInformation-box">
          <div class="input-item clearfix"> <label class="label-disabled" for="">手机号码：</label>
              <input class="input-disabled" name="phone" type="text" disabled value=${certData.tempPhone} placeholder="联系人的电话">
          </div>
          <div class="cert_subtitle"> <span class="icon"></span>如需要修改手机号请在设置中更换手机号</div>
      </div>
      <div class="input-item clearfix"> <label for="">真实姓名：</label> <input type="text" name="real_name" placeholder="请输入认领人的真实姓名">
      </div>
      <div class="input-item clearfix">
          <label for="">邮箱：</label> <input type="text" name="email" placeholder="建议使用包含公司域名后缀的邮箱">
      </div>
      <div class="submit-btn"> <span id="claimProject" class="btn-right" data-key="claimProject">提交认领认证</span>
      </div>
      `
      $(".index-claim .edit").html(_html);
    }
  },
  getBase64: function getBase64(img, cb) {
    // 图片文件转base64
    var dataURL = "";
    img.onload = function () {
      //要先确保图片完整获取到，这是个异步事件
      var canvas = document.createElement("canvas"),
        //创建canvas元素
        imgSize = UTL.getImgSize(img); //确保canvas的尺寸和图片一样
      canvas.width = imgSize.width;
      canvas.height = imgSize.height;
      canvas.getContext("2d").drawImage(img, 0, 0, imgSize.width, imgSize.height); //将图片绘制到canvas中
      dataURL = canvas.toDataURL(); //转换图片为dataURL
      dataURL = dataURL.split("base64,")[1];
      cb && cb(dataURL);
    };
  },
  uploadAvatar: function uploadAvatar(key, cropedImgBase64, datas, cb) {
    var uptoken3, upkey3;
    //Fsize: 文件大小，必选。支持传入 -1 表示文件大小以 http request body 为准。
    var url3 = "https://up-z1.qbox.me/putb64/-1";
    $.ajax({
      url: v1url + "uploader/uptoken",
      type: "GET",
      data: datas,
      headers: {
        token: $.jStorage.get("localToken"),
        devicetoken: cookie_PENCILNEWSID
      },
      success: function success(data) {
        if (data.code == -1) {
          reLoginOnUc();
          return;
        } else if (data.code == 1000) {
          uptoken3 = data.data.uptoken;
          uptoken3 = "UpToken " + uptoken3;
          upkey3 = data.data.key;
          url3 += "/key/" + BASE64.encoder(upkey3);
          if (cropedImgBase64 != undefined) {
            cb && cb(key, cropedImgBase64, url3, uptoken3);
          }
        } else {
          showWarning(data.message);
        }
      }
    });
  },
  putb64Jq: function putb64Jq(key, mypic, myurl, mytoken) {
    $.ajax({
      url: myurl,
      type: "POST",
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: mytoken,
        devicetoken: cookie_PENCILNEWSID
      },
      data: mypic,
      success: function success(data) {
        $(key + " .input-item .img-box .show-img").attr("data-id", data.key);
      }
    });
  }
};

claimProject.handleEvent = {
  init: function init() {
    this.render();
  },
  formValidation: function formValidation(data) {
    if (!(data.real_name.length > 0)) {
      showWarning("请填写您的真实姓名！");
      return false;
    }
    if (!(data.job.length > 0)) {
      showWarning("请填写您担任的职位！");
      return false;
    }
    if (!(!!data.card && data.card.length > 0)) {
      showWarning("请上传您的名片！");
      return false;
    }
    if (!(data.wechat.length > 0)) {
      showWarning("请填写您的微信！");
      return false;
    }
    if (!(data.email.length > 0)) {
      showWarning("请填写您的邮箱！");
      return false;
    }
    if (!validIsEmail(data.email)) {
      showWarning("邮箱格式错误！");
      return false;
    }
    return true;
  },
  render: function render() {
    var that = this;
    // 更换名片
    $(".input-item input[type='file']").change(function () {
      var imgSrc = void 0;
      var cropedImgBase64 = void 0;
      var selectId = $(this).attr("id");
      var f = document.getElementById(selectId).files[0];
      if (f.size > 1024 * 1024 * 2) {
        showWarning("图片大小不得超过2M！");
        return;
      }
      imgSrc = window.URL.createObjectURL(f);
      $(".input-item .img-box").html("<img class=\"show-img\" src=" + imgSrc + " alt=\"\">");
      $(" .input-item .title-box .replace-img").show();
      claimProject.getBase64($(".input-item .img-box .show-img")[0], function (data_cropedImgBase64) {
        claimProject.uploadAvatar(".edit", data_cropedImgBase64, {
          uptype: "4",
          ext: "jpg"
        }, claimProject.putb64Jq);
      });
    });

    // 提交认领认证信息
    $(".submit-btn #claimProject").on("click", function (e) {
      var claimInformation = {
        open_id: claimProject._open_id,
        real_name: $(".edit .input-item input[name='real_name']").val(),
        job: $(".edit .input-item input[name='job']").val(),
        card: $(".edit .input-item .img-box .show-img").attr("data-id"),
        phone: $(".edit .input-item input[name='phone']").val(),
        wechat: $(".edit .input-item input[name='wechat']").val(),
        email: $(".edit .input-item input[name='email']").val()
      };
      if (that.formValidation(claimInformation)) {
        claimProject.submitClaim(claimInformation, function (data) {
          // console.log(data);
          sa.track("createProjectStep",{
            $lib_detail: "认领信息的提交统计##handleEvent##claimProject.js##156",
            step: "认领信息",
            action: "下一步",
            "PlatformType": "PC"
          });
          window.location.href = Pc_Url + "submit_project";
        });
      }
    });
  }
};